import { Component, Input, inject } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';

@Component({
    selector: 'app-default-alert',
    templateUrl: './default-alert.page.html',
    styleUrls: ['./default-alert.page.scss'],
    imports: [IonicModule]
})
export class DefaultAlertPage {
  modalCtrl = inject(ModalController);


  @Input() title;

  confirm() {
    this.modalCtrl.dismiss(null, 'confirm');
  }

  deny() {
    this.modalCtrl.dismiss(null, 'deny');
  }

}
